import classNames from "classnames";
import React, { FC } from "react";

interface LoadingIndicatorProps {
  className?: string;
}

const LoadingIndicator: FC<LoadingIndicatorProps> = ({ className = "" }) => (
  <div className="flex justify-center items-center">
    <div
      className={classNames(
        "w-12 h-12 border-4 border-brand-primary-70 border-solid border-t-transparent rounded-full animate-spin",
        className
      )}
    />
  </div>
);

export default LoadingIndicator;
